import { ProductTypes } from '../../types/product/product';

export const hasNameContaining = (
  searchQuery: string
): Predicate<ProductTypes> => product =>
  product.name.toLowerCase().includes(searchQuery.toLowerCase());
